import { useCallback } from 'react';
import { useGlobalNotifications } from '@/hooks/system/useGlobalNotifications.ts';

// Types matching the existing NotificationsService
export interface TransferPatient {
  id?: number;
  transfer_id: number;
  enrollment_patient_id: number;
  patient_name: string;
  clinic_id: number;
  clinic_name: string;
  assigned_by_user_id: number;
  assigned_by_user_name: string;
  assigned_to_user: number | null;
  assigned_to_user_name: string | null;
  assigned_dt: string;
}

// Hook that uses the global notifications system (no separate WebSocket connection)
export const useGraphQLSubscription = () => {
  // Use the existing global notifications system
  const globalNotifications = useGlobalNotifications();

  // Expose setNotificationCount for external use (placeholder - global notifications manages this)
  const updateNotificationCount = useCallback((count: number) => {
    // Global notifications manages this
  }, []);

  return {
    isConnected: globalNotifications.isConnected,
    isLoading: globalNotifications.isLoading,
    notificationCount: globalNotifications.notificationCount,
    notifications: globalNotifications.notifications,
    setNotificationCount: updateNotificationCount,
    refetch: globalNotifications.refetch
  };
};
